import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class CriticalDatesList extends Component {
    static displayName = CriticalDatesList.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            criticalDates: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Option to Renew", value: "Option to Renew" },
            { label: "Termination Option", value: "Termination Option" },
            { label: "Right of First Refusal", value: "Right of First Refusal" },
            { label: "Other", value: "Other" }]
        };
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetCriticalDatesList();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ criticalDates: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.criticalDates.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.criticalDates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.criticalDates.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.criticalDates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            criticalDates: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.criticalDates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            criticalDates: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying criticalDates
        const currentItems = this.state.criticalDates;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i}>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <div>
                            <NavLink className="noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + candidate.sd_id}
                            >
                                View
                            </NavLink>
                        </div>
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <div>
                            {candidate.site_details ? candidate.site_details.sd_address : ''}<br />
                            {candidate.site_details ? candidate.site_details.sd_address2 : ''}<br />
                            {candidate.site_details ? candidate.site_details.sd_city : ''}, {candidate.site_details ? candidate.site_details.sd_state : ''} {candidate.site_details ? candidate.site_details.sd_zip : ''}
                        </div>
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <div>
                            {candidate.cd_type}
                        </div>
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <div>
                            {moment(candidate.cd_action, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}
                        </div>
                    </td>

                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <div>
                            {candidate.cd_note}
                        </div>
                    </td>
                </tr>
            )
        });

        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Critical Date List - Next 12 Months</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Lease
                                            <FaSort
                                                color={this.state.sort.column === 'cd_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('cd_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '300px' }}>
                                            Address
                                            <FaSort
                                                color={this.state.sort.column === 'cd_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('sd_address')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'cd_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('cd_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'width': '140px' }}>
                                            Critical Date
                                            <FaSort
                                                color={this.state.sort.column === 'cd_action' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('cd_action')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '500px' }}>
                                            Notes/Comments
                                            <FaSort
                                                color={this.state.sort.column === 'cd_note' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('cd_note')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetCriticalDatesList() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetCriticalDatesList?months=12', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ criticalDates: data });
    }
}

